import React, { useEffect, useMemo, useRef } from "react";
import { hot } from "react-hot-loader";
import { Route } from "react-router-dom";
import { map, values } from "ramda";
import { Location } from "history";

import styled from "styles/styled_components";
import ROUTES from "constants/routes";

const StyledMicroApp = styled.div`
  height: 100vh;
  padding: ${(props) => props.theme.spacing.small};
`;

export interface IMicroApp {
  email: string;
  firstName: string;
  lastName: string;
  currentLocation: Location;
  fetchUser: () => void;
  fetchLocations: (permalink: string) => void;
  initFeatureFlags: (permalink: string, email: string) => void;
}

const StorePermalinkFeatureRegex = /\/s\/([A-Za-z0-9\-\_]+)\/.+/g;

function MicroApp({
  currentLocation,
  fetchLocations,
  fetchUser,
  email,
  firstName,
  lastName,
  initFeatureFlags,
}: IMicroApp) {
  const hasInitialized = useRef(false);

  useEffect(() => {
    // App data init
    const locationMatch = StorePermalinkFeatureRegex.exec(
      currentLocation.pathname
    );

    if (!hasInitialized.current && locationMatch) {
      // TODO: Shift this logic down or move route param definitions up
      const permalink = locationMatch[1];
      fetchUser();
      fetchLocations(permalink);
      hasInitialized.current = true; // run once only
    }

    // Segment
    let scheduleView = null;
    if (currentLocation.pathname.match(/schedule\/?$/)) {
      scheduleView = currentLocation.search.match(/dayView/)
        ? "day view"
        : "week view";
    }
    window.analytics.page({ scheduleView });
  }, [currentLocation]);

  useEffect(() => {
    const locationMatch = StorePermalinkFeatureRegex.exec(
      currentLocation.pathname
    );

    if (email && locationMatch) {
      const permalink = locationMatch[1];
      initFeatureFlags(permalink, email);
    }
  }, [email, currentLocation]);

  useEffect(() => {
    if (email && window.analytics) {
      const traits = { name: `${firstName} ${lastName}`, email };
      window.analytics.identify(email, traits);
    }
  }, [email, firstName, lastName]);

  const appRoutes = useMemo(
    () =>
      map(
        (route) => <Route key={route.path as string} exact {...route} />,
        values(ROUTES)
      ),
    [ROUTES]
  );

  return <StyledMicroApp>{appRoutes}</StyledMicroApp>;
}

export default hot(module)(MicroApp);
